import script from "./FormViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./FormViewer.vue?vue&type=script&setup=true&lang=js"

import "./FormViewer.vue?vue&type=style&index=0&id=14faff9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14faff9d"]])

export default __exports__